import React from 'react';
import { ReactComponent as InfoIcon } from '@blink/assets/src/icons/info.svg';

import { AssetToClaimRow } from './AssetToClaimRow';
import { useClaimAssets } from '../hooks/useClaimAssets';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shared/ui';

export const AssetsToClaim = () => {
    const { ids, isVisible } = useClaimAssets();

    const tooltipAccountValue = (
        <div className='flex flex-col justify-center items-start w-[263px] gap-1 [&>p]:m-0 [&>p]:text-sm [&>p]:font-normal'>
            <p>
                Here's where you can find any assets that you
                <br />
                get back from positions that were closed due
                <br />
                to market conditions.
            </p>
        </div>
    );

    return isVisible ? (
        <div className='w-full text-primary mt-[52px]'>
            <div className='flex items-center text-lg pb-6 pl-6'>
                <span>Assets to Claim</span>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <InfoIcon className='w-5 h-5 ml-4' />
                        </TooltipTrigger>
                        <TooltipContent>
                            <>{tooltipAccountValue}</>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>
            <div className='overflow-x-auto [&>th]:font-medium'>
                <table className='border-collapse w-full bg-primary border border-opaque min-w-[950px]'>
                    <thead>
                        <tr
                            className='
                                border-b border-opaque h-[52px] [&>span]:font-medium 
                                [&>th]:font-normal [&>th]:text-left [&>th]:text-primary 
                                [&>th]:w-1/5 [&>th]:bg-background-secondary
                                [&>th:last-child]:text-right 
                                [&>td:last-child]:pr-7 [&>th:last-child]:pr-7 
                                [&>th:first-child]:pl-6 [&>td:first-child]:pl-6'
                        >
                            <th className='w-[250px]'>Asset</th>
                            <th className='font-medium text-left w-full pl-5'>Claim Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {ids.map((id) => (
                            <AssetToClaimRow key={id} assetName={id} />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    ) : null;
};
